import { FONT_SIZE } from 'consts/enum';

export const fontSettingsOption = {
	settings: [
		{
			id: FONT_SIZE.SMALL,
			label: 'Small Font',
			localisedId: 'SMALL_FONT',
			size: 12,
			height: 16,
			padding: '10px 12px',
		},
		{
			id: FONT_SIZE.MEDIUM,
			label: 'Medium Font',
			localisedId: 'MEDIUM_FONT',
			size: 14,
			height: 20,
			padding: '8px 12px',
		},
		{
			id: FONT_SIZE.LARGE,
			label: 'Large Font',
			localisedId: 'LARGE_FONT',
			size: 16,
			height: 20,
			padding: '8px 12px',
		},
	],
	defaultMsg: '(This is the default size)',
};
